import React, { ChangeEvent, KeyboardEvent, useState } from 'react'
import Greeting from './Greeting'
import { UserType} from './HW3'

type GreetingContainerPropsType = {
    users: UserType[] // need to fix any +
    addUserCallback: (name: string) => void// need to fix any +
}
const error = 'Ошибка! Введите имя!'
export const pureAddUser = (name: string, setError: (error: string) => void, setName: (name: string) => void, addUserCallback: (name: string) => void) => {
    // если имя пустое - показать ошибку, иначе - добавить юзера и очистить инпут +
    if (!name.trim()){
        setError(error)
    }else{
        addUserCallback(name)
        setName('')
    }
}
export const pureOnBlur = (name: string, setError: (error: string) => void) => { // если имя пустое - показать ошибку +
    if (!name.trim() ) {
        setError(error);
    }
}

export const pureOnEnter = (e: React.KeyboardEvent<HTMLInputElement>, addUser: () => void) => { // если нажата кнопка Enter - добавить
    if (e.key === 'Enter'){
        addUser()
    }
}

// более простой и понятный для новичков
// function GreetingContainer(props: GreetingPropsType) {

// более современный и удобный для про :)
const GreetingContainer: React.FC<GreetingContainerPropsType> = ({
    users,
    addUserCallback,
}) => {
    // деструктуризация пропсов
    const [name, setName] = useState<string>('') // need to fix any +
    const [error, setError] = useState<string>('') // need to fix any  +

    const setNameCallback = (e: React.ChangeEvent<HTMLInputElement>) => { // need to fix any+
        setName(e.currentTarget.value) // need to fix+
        if(error){setError('')}
    }
    const addUser = () => {

        pureAddUser(name, setError, setName, addUserCallback)
    }

    const onBlur = (e:React.FocusEvent<HTMLInputElement>) => { //добавила +
        pureOnBlur(name, setError);
    }

    const onEnter = (e: React.KeyboardEvent<HTMLInputElement>) => {
        pureOnEnter(e, addUser);
    }

    const totalUsers = users.length // need to fix +
    const lastUserName = users.length > 0? users[users.length - 1].name : ''; // need to fix +

    return (
        <Greeting
            name={name}
            setNameCallback={setNameCallback}
            addUser={addUser}
            onBlur={onBlur}
            onEnter={onEnter}
            error={error}
            totalUsers={totalUsers}
            lastUserName={lastUserName}
        />
    )
}

export default GreetingContainer
